<template>
  <v-dialog
    :value="dialog"
    transition="dialog-bottom-transition"
    width="auto"
    persistent
  >
    <template>
      <v-card>
        <v-overlay
          :value="expired"
          absolute
          class="align-center justify-center"
        >
          <div class="d-flex flex-column align-center">
            <v-btn icon large raised @click="fetchBarcode()"
              ><v-icon :size="35">mdi-refresh</v-icon></v-btn
            >
            <span>Click To Reload</span>
          </div>
        </v-overlay>
        <v-toolbar color="secondary" extended extension-height="5">
          <v-col cols="12" class="py-5 px-0">
            <span class="color-white redeem-reward">{{
              product.redemption_points_offer ? "Store Points" : "Store Clubs"
            }}</span>
            <v-icon class="float-right" color="white" @click="close()"
              >mdi-close</v-icon
            >

            <br />
            <span v-if="product.redemption_points_offer" class="my-balance"
              >My Balance:
            </span>
            <span
              v-if="product.redemption_points_offer"
              class="color-white balance-points"
            >
              {{ total_points_remaining }} points</span
            >
          </v-col>
        </v-toolbar>
        <v-card-text class="px-3 pb-15">
          <v-row class="pt-5">
            <v-col cols="3" class="confetti-left"></v-col>
            <v-col
              cols="6"
              class="d-flex justify-center overflow-hidden position-relative"
            >
              <div class="align-center d-flex justify-center position-relative">
                <img
                  v-if="product.image || product.paywithpoints"
                  :alt="product.name"
                  :src="product.image || require('@/assets/payWithPoints.svg')"
                  style="height: 120px"
                />
                <NoImageAvailable
                  v-else
                  style="height: 120px"
                  :departmentName="
                    getProductDepartmentName(
                      product.parent_categories,
                      product.categories,
                    )
                  "
                  :size="'sm'"
                />
              </div>
            </v-col>
            <v-col cols="3" class="confetti pr-0"></v-col>
            <v-col class="align-center d-flex justify-center">
              <span class="product-name">{{ product.name }}</span>
            </v-col>
          </v-row>
          <v-row class="justify-center py-7 align-center">
            <span class="mr-3 line"></span>
            <span
              class="font-size-sm font-weight-bold primary-color text-uppercase"
            >
              Scan to Redeem in Store
            </span>
            <span class="ml-3 line"></span>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-center pb-10">
              <VueBarcode
                v-if="info.token"
                :width="2"
                :height="70"
                :format="'CODE128'"
                :value="info.token"
                :lineColor="expired ? 'gray' : 'black'"
              >
                could not render BarCode.
              </VueBarcode>
              <div v-else>
                <v-progress-circular
                  indeterminate
                  color="secondary"
                ></v-progress-circular>
              </div>
            </v-col>
          </v-row>
          <v-row
            v-if="product.redemption_points_offer"
            class="justify-center points primary-color"
          >
            {{ product.redemption_points_offer }} Point<span
              v-if="product.redemption_points_offer > 1"
              >s</span
            >
          </v-row>
          <v-row v-else class="justify-center points primary-color">
            Free
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import VueBarcode from "vue-barcode";
import { getProductDepartmentName } from "@/util.js";
import NoImageAvailable from "@/components/Product/NoImageAvailable.vue";
import api from "@/api";

export default {
  name: "RedeemInStoreDialog",
  components: { NoImageAvailable, VueBarcode },
  computed: {
    ...mapGetters("store", {
      total_points_remaining: "total_points_remaining",
    }),
  },
  data() {
    return {
      info: [],
      expired: false,
      timeoutID: null,
    };
  },
  methods: {
    getProductDepartmentName,
    async fetchBarcode() {
      let data;
      if (this.product.redemption_points_offer) {
        data = await api({
          url: `/123/point_offers/redemption_token/${this.product.redemption_points_offer_id}`,
          method: "POST",
        });
      } else {
        data = await api({
          url: `/123/coffee_clubs/redemption_token/${this.product.club_id}`,
          method: "POST",
        });
      }
      if (data.info) {
        this.expired = false;
        this.info = data.info;
        if (this.timeoutID) {
          clearTimeout(this.timeoutID);
        }
        this.timeoutID = setTimeout(() => {
          this.expired = true;
        }, data.info.timeout * 1000);
      }
    },
  },
  props: { close: Function, dialog: Boolean, product: Object },
  watch: {
    async dialog(visible) {
      if (visible) {
        this.fetchBarcode();
      } else {
        this.info = [];
        // if (this.product.redemption_points_offer) {
        //   this.$store.dispatch("store/fetchPoints");
        // } else {
        //   this.$store.dispatch("store/fetchClubs");
        // }
      }
    },
  },
};
</script>

<style scoped>
.header {
  height: 74px;
  background-color: var(--v-secondary-base);
}
.confetti-left {
  background-image: url("~@/assets/Confetti_Left.svg");
  background-repeat: round;
}
.confetti {
  background-image: url("~@/assets/Confetti.svg");
  background-repeat: round;
}
.line {
  width: 35px;
  height: 2px;
  background-color: var(--v-secondary-base);
}
.my-balance {
  color: rgba(255, 255, 255, 0.6);
  font-family: Roboto;
  font-size: 16px;
}
.product-name {
  font-size: 20px;
  font-weight: 600;
  color: black;
}
.points {
  font-size: 24px;
  font-weight: bold;
}
.balance-points {
  font-weight: 600;
}
</style>
